<div class="figure-display" (click)="onFigureClick()">
  <div class="result-icon" *ngIf="showIcon">
    <mat-icon>image</mat-icon>
  </div>
  <div class="result-content">
    <div class="result-header">
      <span class="figure-title" [innerHTML]="result.label"></span>
    </div>
    <div class="result-meta">
      <span *ngIf="result.info?.owner">by {{ result.info.owner }}</span>
    </div>
  </div>
</div>
